export const DELIVERY_PASS_NOT_AVAILABLE = 'NOT_AVAILABLE';
export const DELIVERY_PASS_ACTIVE = 'ACTIVE';
export const DELIVERY_PASS_AVAILABLE = 'AVAILABLE';
